export const hasPerm = (perm) => {
  try {
    const perms = JSON.parse(localStorage.getItem("permisos") || "[]");
    return perms.includes(perm);
  } catch {
    return false;
  }
};
